import { AccountTypeIdEnum } from '../../transactions/enum/account-type-id.enum';
import { ChangeInvestmentInstructionSubmissionTypeEnum } from '../../enum/shared/change-investment-instruction-submission-type.enum';

export class InvestmentInstructionFormRequest {
  public submissionTypeId: ChangeInvestmentInstructionSubmissionTypeEnum;
  public accountTypeId: AccountTypeIdEnum;

  constructor(submissionTypeId: ChangeInvestmentInstructionSubmissionTypeEnum, accountTypeId: AccountTypeIdEnum) {
    this.submissionTypeId = submissionTypeId;
    this.accountTypeId = accountTypeId;
  }
}
